<template>
    <div class="step-progress">
        <h3 class="step-title">{{ title }}</h3>
        <div class="step-content">
            <div class="steps-list">
                <div class="step"
                     v-for="(step, index) of steps"
                     :key="index"
                     @click="goToCallback(index + 1)">
                    <div class="oval"
                         :class="{
                         'current-step': index === currentStep - 1,
                         'step-valid': step.valid && index !== currentStep - 1,
                         'step-invalid': !step.valid && index !== currentStep - 1}"
                    >
                        <img v-if="step.valid && index !== currentStep - 1"
                             src="../../../../assets/img/green-check.svg">
                    </div>
                    <span>{{ step.name }}</span>
                </div>
            </div>
            <div :class="[{ 'multi-actions-footer': isLastStep }, 'step-btn form-footer']">
                <button class="btn-center"
                        :class="!isLastStep ? 'secondary-btn' : 'primary-btn'"
                        :disabled="isDisabled"
                        @click="handleNextButton">
                        {{ buttonsLabels[0] }}

                </button>
                <button 
                    v-if="buttonsLabels.length === 2"
                    :class="!isLastStep ? 'secondary-btn' : 'primary-btn'"
                    :disabled="isDisabled"
                    @click="saveDraftCallback(false)"
                    class="btn-center">
                    {{ buttonsLabels[1] }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StepProgress',
        props: {
            currentStep: {
                type: Number,
                required: true
            },
            steps: {
                type: Array,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            isDisabled: {
                type: Boolean,
                required: true
            },
            nextCallback: {
                type: Function,
                required: true
            },
            saveDraftCallback: {
                type: Function,
                required: false
            },
            goToCallback: {
                type: Function,
                required: true
            },
            isDraft: {
                type:Boolean,
                required:false,
                default:false
            }
        },
        computed:{
            isEdit() {
                return !!this.$route.params.id;
            },
            isLastStep() {
                return this.currentStep === this.steps.length;
            },
            buttonsLabels() {
                if (this.isEdit) {
                        if (this.isDraft) {
                            if (this.isLastStep) {
                                return ["Save and Activate", "Save as Draft"];
                            } else {
                                return ["Continue →"];
                            }
                        } else {
                            if (this.isLastStep) {
                                return ["Save and Done"]
                            } else {
                                return ["Continue →"];
                            }
                        }
                    } else {
                        if (this.isLastStep) {
                            return ["Save and Activate", "Save as Draft"];
                        } else {
                            return ["Continue →"];
                        }
                    }
            }
        },
        methods: {
            handleNextButton() {
                if (this.buttonsLabels[0] === 'Save and Activate' && this.isDraft) {
                    if (this.isEdit) {
                        this.saveDraftCallback(true);
                    } else {
                        this.nextCallback();
                    }
                } else {
                    this.nextCallback();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../assets/colors";

    .step-progress {
        position: sticky;
        top: 5px;
        height: max-content;
        max-height: 400px;
        width: 100%;
        min-width: 250px;
        max-width: 340px;
        margin-left: 30px;
        border-radius: 4px;
        box-shadow: 0 0 20px 0 rgba(176, 186, 197, 0.15);
        background-color: $White;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        @media screen and (max-width: 1200px){
            min-width: 180px;
            max-width: 270px;
        }
        @media screen and (max-width: 991px){
            position: relative;
            max-width: 100%;
            margin-bottom: 20px;
            margin-left: 0;
        }

        .step-title {
            margin: 0;
            padding: 30px 30px 7px;
            font-size: 21px;
        }
        .step-content {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            @media screen and (max-width: 991px){
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
            }
            @media screen and (max-width: 480px){
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: baseline;
            }

            .steps-list {
                padding: 30px;

                @media screen and (max-width: 991px){
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    align-items: center;
                }

                @media screen and (max-width: 480px){
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: baseline;
                    padding: 15px 30px;
                }

                .step {
                    cursor: pointer;
                    display: flex;
                    font-size: 15px;
                    &:not(:last-child) {
                        margin-bottom: 30px;
                        @media screen and (max-width: 991px){
                            margin-bottom: 0;
                        }
                    }
                    @media screen and (max-width: 991px){
                        margin-right: 10px;
                        padding: 10px 0;
                    }
                    .oval {
                        $circleSize: 20px;
                        width: $circleSize;
                        height: $circleSize;
                        margin-right: 11px;
                        img {
                            width: $circleSize - 4px;
                            height: $circleSize - 4px;
                        }
                    }
                    .current-step {
                        border-color: $Violet;
                        background: $Violet !important;
                    }
                    .step-valid {
                        border: 2px solid $Success;
                    }
                    .step-invalid {
                        border: 2px solid $ControlsGrey;
                    }
                }
            }

            .step-btn {
                @media screen and (max-width: 991px){
                    margin-right: 30px;
                    box-shadow: none;
                }
                @media screen and (max-width: 480px){
                    width: 100%;
                    align-items: center;
                    margin-right: 0;
                    box-shadow: 0 0 20px 0 rgba(176, 186, 197, 0.15);
                }

                button {
                    @media screen and (max-width: 991px){
                        width: 155px;
                    }

                    @media screen and (max-width: 480px){
                        width: 188px;
                    }
                }
            }
        }
        .multi-actions-footer {
            display: flex;
            flex-direction: column;
            height: 190px;
            button {
                margin-top: 1rem;
                margin-bottom: 1rem;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/main/pages/base/BaseStepList.vue